module.exports = __webpack_public_path__ + "static/media/footer-ico5.29016534.svg";